import { Button, Checkbox, Input, notification, Pagination, Spin, Table, TablePaginationConfig, Tooltip } from "antd";
import Modal from "antd/lib/modal/Modal";
import moment from "moment-business-days";
import { SetStateAction, useEffect, useState } from "react";
import useLotesImpresionAPI from "../../lotes-impresion/useLotesImpresionAPI";
import Paragraph from "antd/lib/typography/Paragraph";
import ModalDetalle from "./ModalDetalle";
import Velocidad from "./IconosInfraccion/exceso-de-velocidad.png"
import Adelantamiento from "./IconosInfraccion/adelantamiento.png"
import Semaforo from "./IconosInfraccion/luz-roja.png"
import Estacionar from "./IconosInfraccion/no-estacionar.png"
import LucesBajas from "./IconosInfraccion/luces-bajas.png"
import SpinnerLarge from "./SpinnerLarge";
import SinDatos from "./IconosInfraccion/sin-dato.png"
import useInfraccionesAPI, { InfraccionesCallCenter } from "../../infracciones/hooks/useInfraccionesAPI";
import { toNumber } from "lodash";
import { DownloadOutlined } from "@ant-design/icons";
import styled from "styled-components";


const formatDate = (fecha: string) => {
    if(fecha == undefined) return undefined;

    return moment(fecha).format('DD/MM/YYYY');
    }
    

export default (props: any) => {
    const [isModalDescargarVisible, setIsModalDescargarVisible] = useState(false);
    const [isModalRegenerarVisible, setIsModalRegenerarVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<any>(null);
    const [spinVisible, setSpinVisible] = useState<boolean>(false);
    const [tableData, setTableData] = useState([]);
    const apiLoteImpresion = useLotesImpresionAPI();
    const apiInfracciones = useInfraccionesAPI();
    const [diasVencimiento, setDiasVencimiento] = useState(localStorage.getItem('diasVencimiento') || '0');
    const pageSize = 50;
    const [currentPage, setCurrentPage] = useState(1);
    const selectedRowsList = props.selectedRowsList || [];
    const setSelectedRows = props.setSelectedRows || (() => {});
    const [mantenerValores, setMantenerValores] = useState(false);



    const columns = [
        { title: '#', key: 'index', render: (text: any, record: any, index: number) => {return ((currentPage - 1) * pageSize) + index + 1; }},
        { title: "DNI/CUIT", dataIndex: "titular", key: "", render: (titular:any) => titular.cuilTitular },
        { title: "Nombre completo", dataIndex: "titular", key: "", render: (titular:any) => titular.nombreCompletoTitular },
        { title: "Nro Acta", dataIndex: "nroTramite", key: "tramite" },
        { title: "Patente", dataIndex: "patente", key: "patente"},
        { title: "Fecha infracción", dataIndex: "fechaInfraccion", key: "fechaInf", render: (fecha:string) => formatDate(fecha) },
        { title: "Fecha emsión", dataIndex: "fechaEmision", key: "fecha", render: (fecha:string) => formatDate(fecha) },
        { title: "Estado pago", dataIndex: "estadoPago", key: "estpago", render: (estadopago:any) => ( 
            <span style={{ color: estadopago === "PAGADA" ? "#52c41a" : "#ff4d4f" }}>
                {estadopago}
            </span>) },
        { title: "Correo postal", dataIndex: "Correo", key: "", render:(correo:any) => correo?.Estado??'Sin dato' },
        { title: "Regenerada", dataIndex: "regenerada", key: "" },
        { title: "Tipo", dataIndex: "descripcionCodigo", key: "", render: (descripcionCodigo:string) => (
            <Tooltip title={descripcionCodigo == undefined || descripcionCodigo == '' ?'Sin dato':descripcionCodigo}>
                <img src={getIcon(descripcionCodigo)} alt="icono" style={{width: "2em", height: "auto"}} />
            </Tooltip>
        )},
      ];

    useEffect(() => { setTableData(props.tableData); }, [props.tableData]);
    useEffect(() => {localStorage.setItem('diasVencimiento', diasVencimiento);}, [diasVencimiento]);

    const handleRowClick = (record: any) => {
        setSelectedRecord(record);
        setIsModalDescargarVisible(true);
    };

    const handleModalClose = () => {
        setIsModalDescargarVisible(false);
        setSelectedRecord(null);
    };

    const handleDescargarUltimaImpresa =  async () => {
        setSpinVisible(true);
        try {            
            const response = await apiLoteImpresion.getActaPdf(selectedRecord.id);
            if (response.error) throw Error;

           let fileUrl = response.data?.value || "";

            let urlObj;
            try {
            urlObj = new URL(fileUrl); // si es absoluta
            } catch (e) {
            urlObj = new URL(fileUrl, window.location.origin); // si es relativa
            }

            urlObj.pathname = urlObj.pathname.replace(/\/{2,}/g, "/");
            urlObj.searchParams.set("t", Date.now().toString());

            const res = await fetch(urlObj.toString(), { cache: "no-store" });

            if (!res.ok) {
            throw new Error(`HTTP ${res.status}`);
            }
            const pdfBlob = await res.blob();

            const url = window.URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `acta-${selectedRecord.nroTramite}.pdf`); // Nombre del archivo
            document.body.appendChild(link);
            link.click(); // Simular clic para descargar
            document.body.removeChild(link); 
            window.URL.revokeObjectURL(url);
        }
        catch (e) {            
            notification.error({message:'No se puede descargar el PDF...'});
        }
        finally{
            setSpinVisible(false);  
        }
    };

    const handleDescargaResolucionJuzgado = async () => {
        setSpinVisible(true);
        const link = document.createElement('a');
        link.href = selectedRecord.descargo.documentoResolucion.fullUrl;
        link.download = selectedRecord.descargo.documentoResolucion.nombreArchivoOriginal;
        link.target = '_blank'
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setSpinVisible(false);  
    }

    const handleDiasVencimiento = (diasVencimiento:string) => {
        setDiasVencimiento(diasVencimiento);
    }

    const handleRegenerar = () => {
        if(selectedRecord.estadoPago != 'IMPAGA'){
            notification.error({message:'Solo infracciones IMPAGAS...'});
            return;
        }
        setIsModalRegenerarVisible(true);
    };


    const handlePageChange = (page: number) => {
        setCurrentPage(page); // Actualiza la página actual
    };

    const getIcon = (descripcionCodigo:string | '') => {
        const semaforoArray = ['rojo', 'roja', 'rojos', 'rojas', 'verde'];
        const lucesBajasArray = ['bajas', 'baja', 'falta de luces', 'ausencia de luces'];
        const adelantamientoArray = ['adelantarse', 'contramano'];
        const estacionarArray = ['frenar', 'estacionar', 'detenerse'];
        const velocidadArray = ['velocidad'];

        try {
            if(semaforoArray.some((palabra) => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return Semaforo;
            else if (lucesBajasArray.some(palabra => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return LucesBajas;
            else if (adelantamientoArray.some(palabra => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return Adelantamiento;
            else if (estacionarArray.some(palabra => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return Estacionar;
            else if (velocidadArray.some(palabra => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return Velocidad;
            else return SinDatos;
        } catch (error) {
            return SinDatos;
        }
    }

    const rowSelection = {
        onChange: (selectedRowKeys: any, selectedRows: SetStateAction<never[]>) => {
            //setSelectedRows(selectedRows);
            
            setSelectedRows(selectedRowKeys);
        }
        
    }

    const descargarActasSeleccionadas = async () => {
        setSpinVisible(true);
        const $filter = `Id eq ${selectedRowsList.join(' or Id eq ')}`;
        const $query = `$filter=${$filter}`;
        
        try {
           
            const response = await apiLoteImpresion.getLoteByParameter($query, true, true);

            if (response && response.data) {

                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = URL.createObjectURL(blob);
        
                let filename = 'Actas seleccionadas.zip';
        
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
        
                URL.revokeObjectURL(url);
                document.body.removeChild(a);
            } else {
                console.error('La respuesta no contiene el archivo.');
      
            }
        } catch (error) {
            console.error('Error al descargar el archivo:', error);
        
        }finally{
            setSpinVisible(false);
        }
    }

    const updateActa = async () => {
        setSpinVisible(true);
        const response = await apiInfracciones.downloadUpdateActa(selectedRecord.id, toNumber(diasVencimiento), mantenerValores);
        if(response.data){
          setSpinVisible(false);
          window.open(response.data, '_blank');
        }
    
        if (response.message) {
          setSpinVisible(false);
          notification.error({
            message: 'Error al descargar el acta actualizada'
          })
        }
    } 

  return (
    
    <>
        <SpinnerLarge spinning={props.spinnerLoading } tip='' />

        <Table
            columns={columns} 
            dataSource={tableData} 
            rowKey={(record:any)=> record.id} 
            style={{ marginTop: 20}} 
            pagination={{pageSize: pageSize, current: currentPage, onChange: (page)=> handlePageChange(page)}}
            onRow={(record) => {
                return {
                    onDoubleClick: () => handleRowClick(record),
                };
            }}
            rowClassName={(record:any) => {
                return record.estado === "DESCARTADA" ? 'descartada' : "";
            }}
            rowSelection={rowSelection}
            footer={() => (
                <tr style={{ fontWeight: 'bold' }}>
                    <td colSpan={columns.length} style={{ textAlign: 'right' }}>
                        Total de infracciones: {props.tableData.length}
                        {selectedRowsList.length > 0 && (
                        <Button
                            style={{ marginLeft: 10 }}
                            onClick={descargarActasSeleccionadas}
                            loading={spinVisible}
                            type="ghost"
                            icon={<DownloadOutlined></DownloadOutlined>}
                        >
                            Descargar actas seleccionadas
                        </Button>
                    )}
                    </td>
                </tr>
            )}
        />
        

        <ModalDetalle 
            selectedRecord={selectedRecord} 
            formatDate={formatDate} 
            spinVisible={spinVisible} 
            isModalDescargarVisible={isModalDescargarVisible}
            handleModalClose={handleModalClose}
            handleDescargarUltimaImpresa={handleDescargarUltimaImpresa}
            handleRegenerar={handleRegenerar}
            handleDescargaResolucionJuzgado={handleDescargaResolucionJuzgado}
            />

        <Modal
            title="¿Estás seguro?"
            open={isModalRegenerarVisible}
            onOk={(item) => {updateActa(); setIsModalRegenerarVisible(false)}}
            onCancel={() => {console.log('Acción cancelada'); setIsModalRegenerarVisible(false)}}
            okText="Confirmar"
            cancelText="Cancelar"
            okType="primary"        
        >
            <Paragraph>Días de vencimiento: </Paragraph>
            <Input onChange = {(e) => handleDiasVencimiento(e.target.value)} value = { diasVencimiento } size = "small" style = {{ width: "30%" }} type = "number"/>
            <Checkbox 
            style={{ margin: 10}}
              checked={mantenerValores} 
               onChange={(e) => setMantenerValores(e.target.checked)}>
                Mantener valores actuales?
            </Checkbox>
            <Paragraph>Esta por regenerar el acta número {selectedRecord?.nroTramite}. ¿Quieres continuar?</Paragraph>
        </Modal>
        <style>{`
          .descartada {
            background-color: #fff0f0;
            font-weight: bold;
          }
        `}</style>
    </>
  );
};

